export default "__VITE_ASSET__e4d68de5__"